<template>
  <aside class="alert-container">
    <alert-component
      v-for="(alert, key) in alerts"
      v-bind:key="alert.id"
      v-bind:alert="alert"
      v-on:remove="$delete(alerts, key)"
    ></alert-component>
  </aside>
</template>

<script>
import Alert from '@/lib/transfer-objects/Alert'
import AlertComponent from '@/components/Alert.vue'

export default {
  name: 'AlertContainer',
  components: {
    AlertComponent
  },
  data: function () {
    return {
      alerts: []
    }
  },
  created: function () {
    this.$bus.$on('alert', (alert) => {
      if (!(alert instanceof Alert)) {
        throw new Error('Invalid parameter, must be a Alert instance')
      }
      this.alerts.push(alert)
    }

    )
  }
}
</script>

<style lang="sass">
@import './static/sass/variables.sass'

.alert-container
  position: fixed
  width: 20%
  right: 1rem
  bottom: 0
  z-index: 2000
  @media screen and (max-width: map-get($grid-breakpoints, 'm'))
      .alert-container
          width: 40%
  @media screen and (max-width: map-get($grid-breakpoints, 's'))
      .alert-container
          width: 60%
</style>



// WEBPACK FOOTER //
// src/components/AlertContainer.vue